import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Icon from "../../../../components/selfcare/Icon.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../../../util/events.ts";
import OrderAddressSearchComponent from "../../../../components/order/OrderAddressSearchComponent.tsx";

export default function FlytningArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Vi vil rigtig gerne hjælpe dig med at flytte dit abonnement til din nye adresse!
                            Du skal bare gøre følgende:
                        </p>
                        <ol className="list list--number">
                            <li>
                                <p>
                                    Send en mail med nedenstående informationer til <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a>.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        <p>Send mailen fra mailadressen registreret på abonnementet på din fraflytningsadresse.</p>
                                    </li>
                                </ul>
                            </li>
                            <li><p>Vi opretter et nyt abonnement på din nye adresse.</p></li>
                            <li><p>Du får en ordrebekræftelse på dit nye abonnement.</p></li>
                            <li><p>Vi opsiger dit nuværende produkt på din gamle adresse.</p></li>
                            <li>
                                <p>Du får en mail om, at du har opsagt dit gamle abonnement.</p>
                                <ul className="list list--bullet">
                                    <li><p>
                                        Har du aftalt med os, at du tager din nuværende router med til den nye adresse, kan du ignorere, hvis der står i mailen, at du skal returnere den.
                                    </p></li>
                                </ul>
                            </li>
                            <li><p>
                                Installationsprocessen for dit nye produkt starter &ndash; du får en mail med den endelige dato for, hvornår internettet på din nye adresse er klar.
                            </p></li>
                        </ol>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Mailen skal indeholde følgende informationer
                        </h2>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>Din nuværende adresse.</p>
                            </li>
                            <li>
                                <p>Din kommende adresse.</p>
                            </li>
                            <li>
                                <p>Dato hvor du fraflytter nuværende adresse.</p>
                            </li>
                            <li>
                                <p>
                                    Datoen vi skal lukke internettet på din nuværende adresse, hvis den er forskellig fra fraflytningsdatoen.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Dato hvor du flytter til ny adresse &ndash; hvis det er en anden dato end fraflytningsdatoen.
                                </p>
                            </li>
                            <li>
                                <p>Produktet du ønsker på din nye adresse.</p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        <p>
                                            Du kan tjekke tilgængelige produkter ved at{' '}
                                            <button
                                                className={'link'}
                                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                            >
                                                slå din adresse op
                                            </button>.
                                        </p>
                                    </li>
                                    <li>
                                        <p>Det er ikke sikkert, du kan få samme produkt som i dag, da vores produkter varierer afhængig af din adresse.</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <h3>Tjek hvad du kan få på din kommende adresse</h3>
                        <OrderAddressSearchComponent/>
                    </div>
                </div>

                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h2>Skal du overdrage dit internet til en anden person?</h2>
                        <p>
                            Så skal du følge vejledningen i nedenstående artikel:
                        </p>
                        <div className={'button-container'}>
                            <Link
                                className={'button button--montserrat with-icon teal'}
                                to={"/hjaelp/mit-abonnement/overdrag-dit-internet-til-anden-person"}
                            >
                                <span className={'text'}>
                                    Overdrag dit internet til en anden person
                                </span>
                                <Icon component={IconArrow}/>
                            </Link>
                        </div>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "ny-teknikertid",
                        "name": "Sådan ændrer du din teknikertid"
                    },
                    {
                        "category": "bestilling",
                        "article": "ny-online-dato",
                        "name": "Vil du ændre datoen, dit internet er klar?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "overdrag-dit-internet-til-anden-person",
                        "name": "Overdrag dit internet til en anden"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}
